import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('AdditionalRow1', 'Steps', {
	data() {
		return {
			visabilityInner: false,
			selectedPlinth: null,
			needClips: false,
			countClips: 20,
			additional: null,
			plinthCount: null,
			plinthColor: null,
		};
	},
	created() {
		this.getDataStep();
	},
	methods: {
		isAdditionalReady() {
			return this.additional;
		},
		deactivate() {
			this.selectedPlinth = null;
			this.visabilityInner = !this.visabilityInner;

			if (!this.visabilityInner) {
				this.setPropPosition({
					plinthModel: null,
					plinthCount: null,
					countClips: null,
					plinthColor: null,
				});
			}
		},
		toggleClips(value) {
			this.needClips = value;
			if (!this.needClips) {
				this.countClips = 20;
			}
		},
		changeClipsCount(value) {
			this.countClips = value;
		},
		setPlinthValue(value) {
			this.plinthCount = value;
		},
		getDataStep: function () {
			let context = this;
			let req = BX.ajax.runComponentAction(
				'mworks:configurator',
				'getDataAdditional1',
				{
					mode: 'class',
					method: 'post',
					data: {
						position: '',
					},
				}
			);

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.additional = response.data.result;
				}
			});
		},
		setPlinthColor(val) {
			this.plinthColor = val;
		},
	},
	props: ['state', 'step'],
	mounted() {
		this.setPropPosition({ needClips: this.needClips });
	},
	watch: {
		selectedPlinth: function (val) {
			this.setPropPosition({ plinthModel: this.additional.plinth[val] });
		},
		needClips: function (val) {
			if (this.visabilityInner) {
				this.setPropPosition({ needClips: val });
				val
					? this.setPropPosition({
							countClips: Number(this.countClips),
					  })
					: this.setPropPosition({
							countClips: 0,
					  });
			}
		},
		countClips: function (val) {
			if (this.needClips) {
				this.setPropPosition({
					countClips: Number(val),
				});
			} else {
				this.setPropPosition({
					countClips: 0,
				});
			}
		},
		plinthCount(val) {
			this.setPropPosition({
				plinthCount: Number(val),
			});
		},
		plinthColor(val) {
			this.setPropPosition({
				plinthColor: this.additional.plinthColors[val],
			});
		},
	},
	template: `
	<AdditionalRow>
		<AdditionalButton title="Выбрать плинтус" v-show="!visabilityInner" :class="{hidden: visabilityInner}" v-on:setInnerVisibility="visabilityInner = !visabilityInner" />
		<AdditionalInner v-show="visabilityInner" v-if="isAdditionalReady()">
			<AdditionalButtonHide title="плинтус" v-on:setInnerVisibility="deactivate" />
			<ConfigBlockWrap class="mt-48">
				<ConfigBlockWrapTitle>Модель плинтуса</ConfigBlockWrapTitle>
				<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="3">
					<div class="swiper-slide" v-for="(slide, index) of additional.plinth">
						<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
							:class="{active: selectedPlinth === index}" v-on:setActive="selectedPlinth = index" />
					</div>
				</Swiper>
			</ConfigBlockWrap>
			<ConfigBlockWrap class="mt-48">
				<ConfigBlockWrapTitle>Цвет панели</ConfigBlockWrapTitle>
				<PanelsModal :items="additional.plinthColors" v-on:modalItemSelect="setPlinthColor" />
			</ConfigBlockWrap>
			<ConfigBlockWrap class="mt-48">
				<ConfigBlockWrapTitle>Количество</ConfigBlockWrapTitle>
				<ConfigBlockRow>
					<Input class="w-100p sm:w-50p" name="count_plinths" label="Количество плинтуса 2м" v-on:changeValue="setPlinthValue" />
				</ConfigBlockRow>
			</ConfigBlockWrap>
			<ConfigBlockWrap class="mt-48">
				<Checkbox name="add_clips" title="Добавить клипсы" v-on:setChecked="toggleClips" />
			</ConfigBlockWrap>
			<ConfigBlockWrap class="mt-48" v-show="needClips">
				<Input class="w-100p sm:w-50p" name="count_clips" :value="countClips" label="Количество клипс" v-on:changeValue="changeClipsCount" />
			</ConfigBlockWrap>
		</AdditionalInner>
	</AdditionalRow>
`,
});
